import { render, staticRenderFns } from "./MyXpoint.vue?vue&type=template&id=416aae74&"
import script from "./MyXpoint.vue?vue&type=script&lang=js&"
export * from "./MyXpoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports